<template>
  <jet-action-section>
    <template #title>Affiliation</template>

    <template #description>
      Here are the universities and groups you're affiliated with.
      <br />
      To change your university, contact VCE support. For group changes, reach out to your
      administrator.
    </template>

    <template #content>
      <div v-if="universities">
        <div class="font-bold text-gray-600 mt-7">
          {{
            !this.$page.props.isClinician && !this.$page.props.isAdmin
              ? 'University'
              : 'Universities'
          }}:
          <span class="font-medium">{{ universities }}</span>
        </div>
        <div v-if="groups" class="font-bold text-gray-600 mt-7 mb-3">
          Groups:
          <span class="font-medium">{{ groups }}</span>
        </div>
      </div>
      <div v-else>
        <div class="font-bold text-gray-600 mt-5">No affiliations</div>
      </div>
    </template>
  </jet-action-section>
</template>

<script>
import JetActionSection from '@/Jetstream/ActionSection.vue';

export default {
  components: {
    JetActionSection,
  },
  data() {
    this.fetchAffiliation();
    return {
      universities: null,
      groups: null,
    };
  },
  methods: {
    async fetchAffiliation() {
      try {
        const isStudent = !this.$page.props.isClinician && !this.$page.props.isAdmin;
        const response = await axios.get(route(`${isStudent ? 'user' : 'clinician'}.affiliation`));

        if (response.data.universities?.length) {
          this.universities = response.data.universities.join(', ');
        }

        if (response.data.groups?.length) {
          this.groups = response.data.groups.join(', ');
        }
      } catch (error) {
        console.error('Error loading affiliation:', error);
      }
    },
  },
};
</script>
